import {
  getActiveTemplatesApi,
  getSampleTemplatesApi,
  getTemplateStructureApi,
  createTemplateStructureApi,
  updateTemplateStructureApi,
  saveTemplateQuestionsApi,
  getArchivedTemplatesApi,
  archiveTemplateApi,
  duplicateTemplateApi,
  getReviewTemplateQuestionsApi,
} from 'api/templates/review';
import { TemplateMeta } from 'models/templates/review';

export const getActiveTemplates = ({ offset = 0, limit = 100, includeCount = false }) =>
  getActiveTemplatesApi({ offset, limit, includeCount }).then((res) => res.entity);

export const getSampleTemplates = ({ offset = 0, limit = 100, includeCount = false }) =>
  getSampleTemplatesApi({ offset, limit, includeCount }).then((res) => res.entity);

export const getArchivedTemplates = ({ offset = 0, limit = 100, includeCount = false }) =>
  getArchivedTemplatesApi({ offset, limit, includeCount }).then((res) => res.entity);

export const getTemplateStructure = ({ templateId }) =>
  getTemplateStructureApi({ templateId }).then((res) => TemplateMeta.fromJSON(res.entity));

export const createTemplateStructure = ({ body }) => createTemplateStructureApi({ body }).then((res) => res.entity);

export const updateTemplateStructure = ({ templateId, body }) =>
  updateTemplateStructureApi({ templateId, body }).then((res) => res.entity);

export const getReviewTemplateQuestions = ({ templateId, section }) =>
  getReviewTemplateQuestionsApi({ templateId, section }).then((res) => res.entity);

export const saveTemplateQuestions = ({ templateId, section, body }) =>
  saveTemplateQuestionsApi({ templateId, section, body }).then((res) => res.entity);

export const archiveTemplate = ({ templateId, isArchive }) =>
  archiveTemplateApi({ templateId, isArchive }).then((res) => res.entity);

export const duplicateTemplate = ({ templateId }) => duplicateTemplateApi({ templateId }).then((res) => res.entity);
